export const onEmojiPicker = value => ({
  type: "showEmojiPicker",
  value
});

export const setReloadChatApp = () => ({
  type: "reloadChatApp"
});
